<template>
  <div class="table-offer-status flex-end">
    <Badge :color="badgeByStatus" class="offer-badge">
      {{ tenderOfferStatuses[status] }}
    </Badge>
  </div>
</template>

<script>
  import Badge from '@/components/ui/Badge';
  import { mapState } from 'vuex';

  const STATUS_TO_COLOR = {
    offered: 'light-grey',
    archived: 'light-red',
    read: 'orange',
    invited: 'grey-black',
  };
  const DEFAULT_COLOR = 'light-grey';

  export default {
    name: 'OfferStatus',
    components: { Badge },
    props: {
      status: String,
      isOld: {
        type: Boolean,
        required: true,
      },
    },
    computed: {
      ...mapState('global', ['tenderOfferStatuses']),
      badgeByStatus() {
        return STATUS_TO_COLOR?.[this.status] || DEFAULT_COLOR;
      },
    },
  };
</script>
